<style scoped lang="scss">
.service_chan{
  margin-bottom: 20px;
  display: flex;
  overflow: auto;
  flex-wrap: wrap;
  justify-content: space-around;
  .cons{
    display: none;
  }
  li{
    width: 188px;
    height: 188px;
    //margin-right: 12px;
    background: url("../../assets/img/fuwu.jpg") no-repeat!important;
    background-size: auto!important;
    .img{
      width: -moz-fit-content;
      width: fit-content;
      margin-left: auto;
      margin-right: auto;
      padding-top: 20px;
      padding-bottom: 20px;
    }
    p{
      font-size: 16px;
      color:#4e4e4e;
      margin-bottom: 10px;
      width: -moz-fit-content;
      width: fit-content;
      margin-left: auto;
      margin-right: auto;
    }
    .liaojie{
      width: -moz-fit-content;
      width: fit-content;
      margin-left: auto;
      margin-right: auto;
      color:#959595;
      cursor: pointer;
    }
  }
  li:hover{
    background: url("../../assets/img/fuwu1.jpg") no-repeat!important;
    background-size: auto!important;
    p{
      color: #fff;
    }
    .liaojie{
      color: #fff;
    }
  }
  li:last-child{
    margin-right: 0;
  }
}
.wrap-tec{
  margin-bottom: 0;
  .container{
    width:1250px;
  }
  .mr41{
    display: block;
  }
  .mr42{
    display: none;
  }
  .compose-type{
    background: #F6FAFD;
    padding-bottom: 80px;
    margin-top: 100px;
    h4{
      margin-top: 10px;
    }
  }
  .service{
    background: #F6FAFD;
    .lists{
      display: flex;
      justify-content: space-around;
    }
  }
  .support{
    display: flex;
    justify-content: space-between;
    margin-top: 50px;
    li{
      width:360px;
      padding:20px;
      background: #F9F9F9;
      .title{
        font-size: 16px;
        font-weight: bold;
        padding-bottom:10px;
        color: #014492;
        border-bottom: 1px solid #014492;
      }
      dd{
        margin-top:15px;
      }
    }
  }
  .seq-type{
    li{
      p{
        margin-top: 0;
      }
    }
  }
  .table{
    // width:980px;
    margin:0 auto;
  }
  .lists{
    flex-wrap: wrap;
    p{
      white-space: pre-line;
      line-height: 1.6;
    }
    li{
      width: 25%;
      flex: auto;
      margin-top:10px;
      img{
          height: 70px;
      }
      &:nth-last-child(-n+4){
        margin-top:60px;
      }
    }
    
  }
  .compose-type{
    h4{
      font-size: 16px;
    }
  }
}
.img-service{
  width:100%
}
.cons{
  display: none;
}

.c-title small{
  margin-top: 10px;
}
@media screen and (max-width: 640px){
  .mt30{
    margin-top: 0!important;
  }
  .wrap-tec .compose-type {
    margin-top: 20px!important;
  }
  .mr42{
    margin-left: auto;
    margin-right: auto;
    display: block!important;
  }
  .mr41{
    display: none!important;
  }
  .wrap-tec .support{
    margin-top:20px;
  }
  .wrap-tec .support li{
    width: 100% !important;
  }
  .wrap-tec .lists li{
    width:100%;
    margin:20px 0!important;
  }
  .img-service{
    margin-top: 20px;
  }

}



</style>
<style scoped>
@import url("../../assets/sanger.css");
@import url("../../assets/service.css");
</style>
<template>
  <!--  基因合成-->
  <div class="wrap wrap-tec">
    <router-view></router-view>
    <template v-if="!$route.meta.invisible && !$route.meta.invisibles">
      <div class="banner" >
        <!-- alt:擎科生物-提供及时、准确的基因合成服务 -->
        <img src="@/assets/images/banner_19.png" class="img-fluid" alt="基因合成">
        <div class="info">
          <div class="container container3">
            <h2>为您提供及时、准确的</h2>
            <h1>基因合成服务</h1>
            <el-button @click="toOrder" size="mini" class="mt40 mr42">立即合成</el-button>
            <el-button @click="toOrder"  class="mt40 mr41">立即合成</el-button>
          </div>
        </div>
      </div>
      <div  class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;margin-top: 20px;">
        <bread></bread>
      </div>
      <div class="container">
        <en-title title="基因合成" enTitle="Gene Synthesis"/>
        <el-row type="flex" align="bottom" >
          <el-col :span="12">
            <img src="@/assets/images/gen_1.png" class="img-fluid" alt="擎科生物-提供及时、准确的基因合成服务">
          </el-col>
          <el-col :span="12">
            <div class="required">
              <p>擎科生物打通了从DNA合成设备、合成原材料、新合成工艺到基因组装的分子生物学试剂的产业链条，充分的优化了基因合成的每一步生产环节。凭借着一支专业的基因合成技术团队及完备的基因合成流程管理体系，大大的提高了基因合成的成功率和交付率，赢得了生物公司及国内知名实验室的信赖。</p>
              <p class="mt10">依托分子平台及DNA合成平台，擎科生物已成功开发了长片段的快速基因合成技术，率先进入商业化应用领域。我们将不断的进行技术创新和探索，为您提供高品质的基因合成服务。</p>
              <p class="mt10">免责声明：擎科仅在客户提供的序列基础上提供基因合成服务，并将基因合成的结果产物交付给客户，客户是基因合成结果产物的真正所有者，今后由基因合成结果产物使用造成的一切后果，其责任概由基因合成结果产物的使用人承担，与擎科无关。特此声明！</p>
            </div>
          </el-col>
        </el-row>
        <en-title title="服务类型" enTitle="Service Type"/>
        <p class="title-desc">
          擎科生物可为客户提供长达200 kb的高质量、快速的基因合成、长单链DNA合成（ssDNA）等服务，还提供<router-link to="/products/Fixed-mutation">定点突变服务</router-link>、<router-link to="/products/Plasmid_Extraction">质粒抽提服务</router-link>，可满足生命科学研究、生物制药、生物育种、生物制造、基因存储等领域的需求。
        </p>
        <table class="table c-title1">
          <tr>
            <th>合成类型</th>
            <th>基因长度</th>
            <th>服务特点</th>
            <th>应用</th>
          </tr>
          <tr>
            <td>标准基因合成</td>
            <td>≤ 10 kb</td>
            <td>标准服务</td>
            <td>生命科学研究</td>
          </tr>
          <tr>
            <td>大片段及基因组合成</td>
            <td>10 - 200 kb</td>
            <td>酵母体内组装技术</td>
            <td>合成基因组</td>
          </tr>
          <tr>
            <td>快速基因合成</td>
            <td>≤ 1.2 kb</td>
            <td>快速通道，及时交付</td>
            <td>强时效项目</td>
          </tr>
          <tr>
            <td>pETgene基因合成</td>
            <td>≤ 10 kb</td>
            <td>深度优化序列</td>
            <td>原核表达</td>
          </tr>
          <tr>
            <td>mRNA poly(A) 基因合成</td>
            <td>≤ 5 kb</td>
            <td>长达120个 poly(A)序列</td>
            <td>mRNA 疫苗相关</td>
          </tr>
          <tr>
            <td>DNA 片段合成</td>
            <td>≤ 1.2 kb</td>
            <td>简单基因的构建、改造</td>
            <td>质粒构建</td>
          </tr>
          <tr>
            <td>长单链 DNA 合成</td>
            <td>≤ 6000 nt</td>
            <td>低细胞毒性，高编辑效率</td>
            <td>CRISPR 同源修复</td>
          </tr>
        </table>
      </div>
      <div class="compose-type">
        <en-title title="产品优势" enTitle="Advantages"/>
        <p class="title-desc">
          擎科生物基因合成以专业的技术优势和优质的服务优势，为广大客户提供值得信赖的产品和服务。
        </p>
        <div class="container">
          <ul class="lists">
            <li v-for="(item,index) in advantagesList" :key="index">
              <img :src="require(`@/assets/images/${item.img}.png`)" :alt="`擎科生物-基因合成服务优势-${item.title}`">
              <h4>{{item.title}}</h4>
              <p>{{item.text}}</p>
            </li>
          </ul>
        </div>
      </div>
      <div class="container">
        <en-title title="服务流程" enTitle="Service Process"/>
        <div class="tc">
          <img class="img-service con" src="@/assets/images/gene_process.png" 
          alt="擎科生物-基因合成服务流程：Day1.序列分析和方案设计 Day2.克隆到载体 Day3.筛选与测序 Day5.质检和发货">
          <!-- 手机端 -->
          <img class="img-service cons" src="@/assets/images/gene_process_mobile.png" 
          alt="擎科生物-基因合成服务流程：Day1.序列分析和方案设计 Day2.克隆到载体 Day3.筛选与测序 Day5.质检和发货">
        </div>
        <ul class="support">
          <li>
            <div class="title">我们可以提供的服务</div>
            <dl>
              <dd>免费提供基因的参考设计方案；</dd>
              <dd>酶切位点的设计、密码子的优化等；</dd>
              <dd>可将合成的基因克隆到指定的载体上；</dd>
              <dd>签订的基因合成服务协议和保密合同；</dd>
            </dl>
          </li>
          <li>
            <div class="title">交付结果</div>
            <dl>
              <dd>基因合成报告单；</dd>
              <dd>测序图谱& 质粒结构图；</dd>
              <dd>冻干质粒DNA一管（约4μg/管）；</dd>
              <dd>含有相应质粒的穿刺菌一管；</dd>
            </dl>
          </li>
          <li>
            <div class="title">您需要准备的</div>
            <dl>
              <dd>请将基因序列及要求发送至我公司合成邮箱；</dd>
              <dd>请务必留下您的联系方式，以便及时沟通；</dd>
              <dd>如需连接到特殊指定载体，请单独提供给我们；</dd>
              <dd>如需我们做密码子优化服务，请提供以下信息；</dd>
            </dl>
          </li>
        </ul>
        <en-title title="基因合成常见问题" enTitle="FAQ"/>
        <div class="container container1">
          <div class="questions questions1">
            <el-collapse v-model="activeNames">
              <el-collapse-item title="Q-1、我为什么要选择送到擎科做基因合成，而不自己克隆？" name="1">
                <p>擎科基因合成通常比自己克隆更便宜，可以为您节省资金。</p>
                <p>擎科基因合成通常比自己克隆更快，可以为您节省时间。</p>
                <p>基因合成消除了传统克隆所需的设计限制。</p>
                <p>基因合成可以获得自然界中原本不存在的 DNA 模板。</p>
              </el-collapse-item>
              <!-- <el-collapse-item title="Q-2、擎科基因合成服务都包括哪些？" name="2">
                <p>根据合成方式，周期及交付形式的不同，擎科提供个性化的合成方案包括：快速基因合成、常规基因合成、长片段基因合成、DNA片段合成、PCR克隆、亚克隆、定点突变等服务。</p>
              </el-collapse-item> -->
              <el-collapse-item title="Q-2、擎科对于合成高难度的基因，如高低GC，重复结构，序列较长，特殊元件等，如何解决的？" name="2">
                <p>高低GC，重复结构</p>
                <p>解决方案：分小段来降低结构对合成的影响，选择最优连接方案，如酶切连接、多段重组。</p>
                <p>序列较长</p>
                <p>解决方案：分小段，使用多段重组来构建，体外组装与体内组装相结合。 </p>
                <p>特殊载体元件（如CCDB，LTR）</p>
                <p>解决方案：针对不同的特殊元件更换相对应的特定感受态细胞，如抗CCDB的DB3.1，重组缺陷型的Stbl系列等。</p>
                <p>其他不可预测的难度，如基因不稳定、有毒性，导致常规克隆菌致死，引入随机突变、缺失；</p>
                <p>解决方案：尝试不同的感受态细胞。</p>
              </el-collapse-item>
              <el-collapse-item title="Q-3、是否提供密码子优化？优化后对基因表达有影响吗？" name="3">
                <p style="text-align: justify">擎科提供免费的密码子优化。同一氨基酸在不同宿主中，其对应的密码子会表现出不同程度的偏好性。密码子优化即利用偏好密码子并避免稀有密码子，从而优化序列在指定宿主中的表达。基因表达水平与密码子偏好性之间存在强相关性。擎科独有的 GeneOptimizer 软件密码子优化算法，支持上万种宿主优化和定制化服务。优化的主要参数包括：密码子偏好性、GC含量、酶切位点（删除）、ploy结构、序列重复等。</p>
              </el-collapse-item>
              <el-collapse-item title="Q-4、擎科默认使用什么载体？是否可以使用指定载体？" name="4">
                <p>擎科默认免费提供含Amp（氨苄青霉素）的pUC57载体；</p>
                <p>擎科载体库有160+种可选，供您免费使用。</p>
                <p>您也可以自备载体，只需提供载体序列和载体样品，另自备载体建议提前邮寄，否则构建周期一般需要增加3个工作日用来验证载体。</p>
              </el-collapse-item>
              <el-collapse-item title="Q-5、合成的基因将被克隆至pUC57载体的什么位点？" name="5">
                <p>擎科默认构建在pUC57载体的EcoRⅠ和HindⅢ之间，并且删除了pUC57载体的其他位点。如果有特殊需求可备注，我们可以依据您的序列和后续实验需求选择指定的克隆位点。</p>
              </el-collapse-item>
              <el-collapse-item title="Q-6、我需要提供什么信息评估序列价格和周期？" name="6">
                <p>我们需要您提供DNA序列或氨基酸序列，如需密码子优化还需提供宿主物种，5’/3’端所需的限制性位点和/或避免内部修饰，以及您是否想要任何其他添加的序列（例如，Kozak 序列、终止密码子等）。您也可以填写评估表格通过邮件发送至gene@tsingke.com.cn，技术支持将会尽快为你估算价格和周期，很快您就可以收到一份详细报价单。</p>
              </el-collapse-item>
              <el-collapse-item title="Q-7、除了合成每个碱基对的费用外，有没有其他额外的费用？ " name="7">
                <p style="text-align: justify">技术支持将根据序列分析结果和基因合成收费标准，为您提供合理的报价。合成常规基因(无高GC含量，无低GC含量和无正向或反向重复序列等)并选择擎科生物提供的免费载体完成克隆的服务，将按碱基单价和序列长度作为收费标准，给予最终报价；合成难度基因(高GC含量，低GC含量和正向或反向重复序列等)或者订单包含亚克隆需求等的服务，我们会在报价单上列出除基因合成以外的收费明细，同时给予最终报价。</p>
              </el-collapse-item>
              <el-collapse-item title="Q-8、最终交付的产品包括什么？" name="8">
                <p>擎科基因产品交付物包括发货产物和电子报告。电子报告为：测序峰图文件、COA报告；发货产物的标准内容为:冻干质粒1管(-20℃保存)以及含有重组质粒的穿刺菌1管(4℃保存，尽量在一周内使用)，若您选择甘油菌，请于-80℃保存。</p>
                <p>注：如对交付产物有其他要求，请在下单时特别备注。</p>
              </el-collapse-item>
              <el-collapse-item title="Q-9、我的序列信息会不会被泄露？" name="9">
                <p>擎科生物始终保持与客户的长期合作，严格的保密措施赢得了客户和广大合作者的充分信任和良好反馈。擎科生物承诺客户提供的任何序列信息和材料严格保密，绝不透露给第三方，签订保密协议。</p>
              </el-collapse-item>
              <!-- <el-collapse-item title="Q-11、COA中酶切验证的酶切位点的选择标准？" name="11">
                <p>酶切验证是除测序结果外另一种验证质粒是否正确的有效判断条件： </p>
                <p>a.优先选择首尾位点；</p>
                <p>b.优先选择双酶切，且两条带的大小不一样；</p>
                <p>c.当出现片段太小将导致电泳图不明显或分离的条带距离太近不容易分开情况时，我们会选择最能说明质粒本身特征的其他位点。</p>
              </el-collapse-item> -->
              <el-collapse-item title="Q-10、订单开始后，我如何了解项目进展？" name="10">
                <p>登陆擎科账号即可在您的系统中查询项目进度；或邮件至gene@tsingke.com.cn，我们24小时客服会及时回复您。</p>
              </el-collapse-item>
              <el-collapse-item title="Q-11、擎科生物通过什么方法判定最终合成基因质量和正确性？" name="11">
                <p style="text-align: justify">擎科生产操作严格按照实验室规范SOP，基因纯度、总量、完整性、序列一致性等完全符合国家标准合成基因质量评价通则(GB/T37873-2019)。擎科是通过挑单克隆来制备发货样品，保证样品单一；其次会对单克隆先进行Sanger测序验证，测序结果会覆盖合成的基因全长序列，以及基因上下游不少于50bp的载体骨架序列，确保基因正确、并且克隆在指定的载体位置；然后对质粒做NGS质检，检验全质粒测序是否准确，确保载体质粒功能元件的完全正确，同时能检测外源基因的污染；最终发货前会经过严格的QC审核，擎科会通过邮件形式将订单的发货文件和发货单发送至您的邮箱。</p>
              </el-collapse-item>
              <el-collapse-item title="Q-12、擎科生物的发货样品会留样保存多久，可以要求补发吗？" name="12">
                <p>擎科生物基因合成订单原则上保存一年，期间可用该订单发货质粒为模板做点突变或克隆等其他服务；客户提供的无问题载体，保存一年。客户收到质粒一个月内如有质量问题，我们可以免费补发。</p>
              </el-collapse-item>
              <el-collapse-item title="Q-13、在大肠杆菌表达系统中，哪种终止密码子具有偏好性？在哺乳动物系统中呢？" name="13">
                <p>在大肠杆菌中，使用频率是：TAA＞TGA，TAG很少用；在哺乳动物中，TGA的使用频率高于TAA和TAG。</p>
              </el-collapse-item>
              <el-collapse-item title="Q-14、擎科生物基因合成交付物使用时应该注意什么？" name="14">
                <h4>干粉质粒使用时应先根据您所需实验浓度进行稀释(可用无菌双蒸水或者TE)。</h4>
                <h4 style="text-align: justify">稀释方法：<span style="font-weight:normal;">稀释前建议先低速离心，使质粒沉于管底避免开盖时造成质粒量的损失影响您后续实验，稀释后避免反复冻融。稀释案例: 4 μg=4000 ng，加入40 μL无菌双蒸水或者TE后充分混匀，即得质粒浓度为100 ng/μL。</span></h4>
                <h4>所交付质粒不建议直接用于转染细胞或蛋白表达。</h4>
                <h4 style="text-align: justify">解决方案：<span style="font-weight:normal;">如您需要做相关实验请您进行质粒转化然后挑取单菌落培养，使用符合要求的质粒抽提试剂盒提取高标准质粒，擎科生物也提供相关质粒抽提服务，如您对质粒要求比较高，可以在确认下单时额外选择质粒抽提服务。</span></h4>
                <h4>甘油菌和穿刺菌在使用前建议您进行复苏。</h4>
                <h4 style="text-align: justify">复苏步骤：<span style="font-weight:normal;">将甘油菌或穿刺菌(挑取其中的菌线以得到菌体)在新鲜配制的固体LB培养基(相应抗性)中划线培养，37℃培养箱过夜培养，挑取4-5个单克隆，分别接种于相应抗性的LB液体培养基中，37℃ 摇12h-15h 达到菌液最佳生长状态后(一般OD600约为0.6)方可用于质粒抽提，摇菌时间最好不要超过15h;若是低拷贝数质粒，可多收菌液大提质粒然后进行质粒的提取和验证。考虑到实验的严谨性,建议抽提质粒后务必测序验证。</span></h4>
                <h4>甘油菌或穿刺菌在使用时比较容易受到污染。</h4>
                <h4 style="text-align: justify">解决方案：<span style="font-weight:normal;">请使用时注意无菌操作,出现菌液不长或提取质粒遇到困难时，建议您使用干粉质粒转化挑单克隆进行培养。</span></h4>
                <h4>我们提供的甘油菌由于运输等因素影响建议不要直接作为保种使用。</h4>
                <h4 style="text-align: justify">解决方案：<span style="font-weight:normal;">若需要保种，可通过划线挑取单克隆进行活化，菌生长对数期时加入15%甘油-80℃长期保存。</span></h4>
              </el-collapse-item>
            </el-collapse>
          </div>
        </div>
        <en-title title="相关服务" enTitle="Related Services"/>
        <ul class="service_chan con">
          <li v-for="(item, index) in gene1" :key="index" class="pointer" :class="{active: currentType === index}" @mouseover="currentType = index" @mouseout="currentType = -1" @click="$router.push(item.ref)">
            <div class="img">
              <img :src="`/static/img/fenzi1_${index+1}${currentType === index ? '' : '_active'}.png`">
            </div>
            <p>{{item.name}}</p>
            <div class="liaojie" @click="$router.push(item.ref)">了解更多></div>
          </li>
        </ul>
        <ul class="service_chan cons" style="margin-top: 20px;">
          <li v-for="(item, index) in gene1" :key="index" class="pointer"   @click="$router.push(item.ref)">
            <div class="img">
              <img :src="`/static/img/fenzi1_${index+1}${currentType === index ? '' : '_active'}.png`" style="width: 50px;height: 55px;">
            </div>
            <p>{{item.name}}</p>
            <div class="liaojie" @click="$router.push(item.ref)">了解更多></div>
          </li>
        </ul>
      </div>
      <!--订购与咨询-->
      <div class="container">
          <new-consult type="gene" :typeList="['orderOnline','telePhone','download','email']"></new-consult>
      </div>
      <!-- <qk-consult type="gene"/> -->
      <!--在线订购-->
      <qk-online-order @order="toOrder"/>
    </template>
  </div>
</template>

<script>
import OnlineOrder from '@/components/onlineOrder'
import bread from "@/components/bread"
export default {
  components: {
    bread,
    'qk-online-order': OnlineOrder
  },
  data () {
    return {
      currentType: -1,
      gene1: [
        {name: '引物合成',img: '1', ref: '/tec/compose1'},
        {name: '常规分子项目',img: '7', ref: '/products/Conventional_molecular_project'},
        {name: '生物试剂',img: '6', ref: '/molecular-reagent'},
      ],
      activeNames: [],
      advantagesList:[
        {
          img:'gen_icon_1',
          title:'全产业链',
          text:'基因合成全产业链\n自主合成原料、设备与工艺',
        },
        {
          img:'gen_icon_2',
          title:'高准确率',
          text:'Sanger测序、NGS\n双重QC保准确',
        },
        {
          img:'gen_icon_3',
          title:'快速交付',
          text:'基因合成智能化产线\n快至3天交付',
        },
        {
          img:'gen_icon_4',
          title:'长达200 kb',
          text:'大片段DNA合成智能组装系统\n合成长度可达200 kb',
        },
        {
          img:'gen_icon_5',
          title:'免费密码子优化',
          text:'降低序列合成难度\n提高蛋白表达量',
        },
        {
          img:'gen_icon_6',
          title:'免费载体库',
          text:'提供160+\n免费载体',
        },
        {
          img:'gen_icon_7',
          title:'酵母体内组装技术',
          text:'自主研发\n酵母组装系统',
        },
        {
          img:'gen_icon_8',
          title:'定制化服务',
          text:'无污染解决方案-无菌、\n无其他质粒、无动物源污染',
        },
      ]
    }
  },
  methods: {
    toOrder () {
      this.$router.push('/tec/order_gene')
    }
  }
  // beforeRouteLeave (to, from, next) {
  //   if (to.path === '/tec/order_gene') {
  //     to.meta.keepAlive = false
  //   }
  //   next()
  // }
}
</script>



// WEBPACK FOOTER //
// src/views/tec/gen_compose.vue